import React, { useEffect, useState } from "react";
import "../Assests/Commitleaderboard.css";
import { getLatestGitActivity } from "../Db_Connections/gitActivityApi";

const MEDAL = { 0: "🥇", 1: "🥈", 2: "🥉" };

function CommitLeaderboard() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLeaderboardData();
  }, []);

  const fetchLeaderboardData = async () => {
    try {
      const { data: events, error } = await getLatestGitActivity();

      console.log("Leaderboard raw data:", events);
      console.log("Leaderboard error:", error);

      if (error) {
        console.error("Error fetching leaderboard data:", error.message);
        return;
      }

      if (!events || events.length === 0) {
        console.log("No rows found in events table");
        return;
      }

      // User-wise commit count store karne ke liye
      const userCommitCount = {};

      events.forEach((item) => {
        const userName = item.user || "Unknown User";

        // Agar user pehli baar mila hai to uska object banao
        if (!userCommitCount[userName]) {
          userCommitCount[userName] = {
            name: userName,
            username: userName.toLowerCase().replace(/\s+/g, ""),
            commits: 0,
            avatar: userName.charAt(0).toUpperCase(),
            color: getRandomColor(userName),
          };
        }

        // Har row ko 1 commit/activity count karo
        userCommitCount[userName].commits += 1;
      });

      // Object ko array me convert karke commits ke hisaab se sort karo
      const sortedUsers = Object.values(userCommitCount).sort(
        (a, b) => b.commits - a.commits
      );

      console.log("Grouped Leaderboard Data:", userCommitCount);
      console.log("Sorted Leaderboard Data:", sortedUsers);

      setData(sortedUsers);
    } catch (err) {
      console.error("Unexpected error:", err);
    } finally {
      setLoading(false);
    }
  };

  const getRandomColor = (name) => {
    const colors = ["#7c3aed", "#0ea5e9", "#10b981", "#f59e0b", "#ef4444"];
    return colors[name.length % colors.length];
  };

  if (loading) {
    return <p>Loading leaderboard...</p>;
  }

  if (data.length === 0) {
    return <p>No commit data found</p>;
  }

  const max = data[0].commits;

  return (
    <div className="clb-card">
      {/* Header */}
      <div className="clb-header">
        <div className="clb-header-left">
          <span className="clb-icon">📊</span>
          <div>
            <div className="clb-title">Daily Commits</div>
            <div className="clb-subtitle">Sorted by most commits today</div>
          </div>
        </div>
        <span className="clb-date">
          {new Date().toLocaleDateString("en-IN", {
            day: "numeric",
            month: "short",
          })}
        </span>
      </div>

      <div className="clb-divider" />

      {/* List */}
      <div className="clb-list">
        {data.map((user, i) => {
          const pct = Math.round((user.commits / max) * 100);

          return (
            <div
              key={user.username}
              className={`clb-row ${i === 0 ? "clb-row-top" : ""}`}
            >
              {/* Rank */}
              <div className="clb-rank">
                {MEDAL[i] ?? <span className="clb-rank-num">{i + 1}</span>}
              </div>

              {/* Avatar */}
              <div className="clb-avatar" style={{ background: user.color }}>
                {user.avatar}
              </div>

              {/* Name + Bar */}
              <div className="clb-info">
                <div className="clb-name-row">
                  <span className="clb-name">{user.name}</span>
                  <span className="clb-commits">{user.commits} commits</span>
                </div>

                <div className="clb-bar-bg">
                  <div
                    className="clb-bar-fill"
                    style={{
                      width: `${pct}%`,
                      background: user.color,
                    }}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default CommitLeaderboard;